import type { BaseIconProps } from "@/assets/icons/utils";
import { fromGitpodSize } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconSidebarSimpleLeftSquareFilled: FC<BaseIconProps> = ({ size, className, ...props }) => {
    const dimensions = fromGitpodSize(size);

    return (
        <svg
            className={className}
            {...props}
            width={dimensions}
            height={dimensions}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M8.75 4V12V20" stroke="currentColor" strokeWidth="1.5" />
            <rect x="4" y="4" width="5" height="16" fill="currentColor" />
        </svg>
    );
};
